module.exports = __webpack_public_path__ + "static/img/teamHonorBg10.00be3fd1.png";